export default {
  title: "Merchandising"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5022: { text: "Ocurrió un error en el catálogo de Merchandising" }
    , WS5022: { text: "Ocurrió un error en el catálogo de Merchandising" }
    , JS5022: { text: "Ocurrió un error en el catálogo de Merchandising" }
    , CR5022: { text: "Ocurrió un error en el catálogo de Merchandising" }
    , UK_Merchandising: { text: "Ya existe un registro con la misma descripción" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/merchandising.js